"use client"; // ce composant s'exécute dans le navigateur (nécessaire pour useState et les événements)

import { useState } from 'react'; // useState : mémorise une valeur et notifie React quand elle change
import Link from 'next/link';     // navigation sans rechargement de page
import { Landmark } from 'lucide-react';
import PasswordInput from '@/components/PasswordInput/PasswordInput';
import styles from '@/app/connexion/page.module.css';

export default function InscriptionPage() {
  // useState("") : crée une variable + sa fonction de mise à jour
  // setEmail("x") → React réaffiche le composant avec email = "x"
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  // déclarée ici pour avoir accès aux états ci-dessus (closure)
  // async : peut contenir des await sans bloquer le navigateur
  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault(); // annule le rechargement de page par défaut du navigateur
    setError("");

    if (password !== confirm) {
      setError("Les mots de passe ne correspondent pas");
      return;
    }

    // fetch envoie la requête HTTP — await met handleSubmit en pause
    // jusqu'à réception de la réponse (le navigateur reste réactif)
    const res = await fetch("/api/auth/register", {
      method: "POST",
      headers: { "Content-Type": "application/json" }, // on envoie du JSON
      body: JSON.stringify({ email, password }),        // objet JS → texte JSON
    });

    if (res.ok) {
      setSuccess(true);
    } else {
      // res contient les en-têtes mais pas encore le corps
      // res.json() lit le corps en flux — d'où le await
      const data = await res.json();
      setError(data.detail ?? "Une erreur est survenue"); // ?? : valeur par défaut si null/undefined
    }
  }

  return (
    <div className={styles.page}>
      <div className={styles.illustration}>
        <Link href="/">
          <Landmark size={80} color="#2d7a4f" strokeWidth={1.2} />
          <span className={styles.sitename}>Civex</span>
        </Link>
        <p className={styles.tagline}>
          L'annuaire des initiatives civiques en France
        </p>
      </div>

      <div className={styles['form-side']}>
        <div className={styles['form-box']}>
          <h1>Créer un compte</h1>

          {/* si success est true → message de confirmation, sinon → formulaire */}
          {success ? (
            <p className={styles.success}>
              Un email de vérification a été envoyé. Consultez votre boîte de réception.
            </p>
          ) : (
            <form onSubmit={handleSubmit}>
              <div className={styles.field}>
                <label htmlFor="email">Adresse email</label>
                <input
                  type="email" id="email" name="email"
                  placeholder="vous@exemple.com"
                  value={email}                              // champ contrôlé par React
                  onChange={e => setEmail(e.target.value)}  // e.target.value : ce que l'utilisateur a tapé
                  required
                />
              </div>

              <div className={styles.field}>
                <label htmlFor="password">Mot de passe</label>
                <PasswordInput id="password" name="password" placeholder="••••••••" value={password} onChange={e => setPassword(e.target.value)} required />
              </div>

              <div className={styles.field}>
                <label htmlFor="confirm">Confirmer le mot de passe</label>
                <PasswordInput id="confirm" name="confirm" placeholder="••••••••" value={confirm} onChange={e => setConfirm(e.target.value)} required />
              </div>

              {/* error && : n'affiche le paragraphe que si error est non vide */}
              {error && <p className={styles.error}>{error}</p>}

              <button type="submit" className={styles.btn}>Créer mon compte</button>

              <div className={styles.links}>
                <Link href="/connexion">Déjà un compte ? Se connecter</Link>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
